export class VivawalletPaymentNotification {

    constructor(
        public transactionId: string,
        public orderCode: string,
        public language: string,
        public eventId: number,
        public eci: number
    ){}
}
